export function isUnread(notification) {
    return !notification.readAt;
}
export function getNotificationIcon(type) {
    switch (type) {
        case "task_assignment":
            return "📋";
        case "task_comment":
            return "💬";
        case "due_date_reminder":
            return "⏰";
        case "overdue_task":
            return "🚨";
        case "project_update":
            return "📊";
        case "workspace_invite":
            return "👥";
        default:
            return "🔔";
    }
}
export function getNotificationColor(type) {
    switch (type) {
        case "task_assignment":
            return "blue";
        case "task_comment":
            return "green";
        case "due_date_reminder":
            return "yellow";
        case "overdue_task":
            return "red";
        case "project_update":
            return "purple";
        case "workspace_invite":
            return "indigo";
        default:
            return "gray";
    }
}
export function groupNotificationsByType(notifications) {
    const groups = notifications.reduce((acc, notification) => {
        const type = notification.type;
        if (!acc[type]) {
            acc[type] = [];
        }
        acc[type].push(notification);
        return acc;
    }, {});
    return Object.entries(groups).map(([type, notifications]) => ({
        type: type,
        notifications,
        count: notifications.length,
    }));
}
export function formatNotificationTime(createdAt) {
    const date = new Date(createdAt);
    const now = new Date();
    const diffInMinutes = Math.floor((now.getTime() - date.getTime()) / (1000 * 60));
    if (diffInMinutes < 1) {
        return "Just now";
    }
    else if (diffInMinutes < 60) {
        return `${diffInMinutes}m ago`;
    }
    else if (diffInMinutes < 1440) {
        const hours = Math.floor(diffInMinutes / 60);
        return `${hours}h ago`;
    }
    else {
        const days = Math.floor(diffInMinutes / 1440);
        return `${days}d ago`;
    }
}
export function getNotificationPriority(type) {
    switch (type) {
        case "overdue_task":
            return 1;
        case "due_date_reminder":
            return 2;
        case "task_assignment":
            return 3;
        case "task_comment":
            return 4;
        case "project_update":
            return 5;
        case "workspace_invite":
            return 6;
        default:
            return 7;
    }
}
export function sortNotificationsByPriority(notifications) {
    return [...notifications].sort((a, b) => {
        // First sort by read status (unread first)
        if (isUnread(a) && !isUnread(b))
            return -1;
        if (!isUnread(a) && isUnread(b))
            return 1;
        // Then by priority
        const priorityDiff = getNotificationPriority(a.type) - getNotificationPriority(b.type);
        if (priorityDiff !== 0)
            return priorityDiff;
        // Finally by creation time (newest first)
        return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
    });
}
